import { Link } from "react-router-dom";
import Return_arrow from "../../../assets/images/svg/return_arrow.svg";
import { base_url } from "../../../constants";
import { propsBreadCrumb } from "../../../models/Colecciones.model";

export default function BreadCrumb(props: propsBreadCrumb) {
    
    return(
        <>
        <div className="container-fluid px-0">
            <div className="row mx-3 mx-sm-0">
                <div className="col-12 mt-4 px-0 top_breadcrumb text-end">
                    <nav aria-label="breadcrumb" className="mb-0 col-12 px-5 d-none d-sm-block">
                    <ol className="col-12 breadcrumb contenedor_breadcrumb mb-0">
                        <li className="breadcrumb-item"><Link to={`/${base_url}/${props.url}/`}>Colecciones</Link></li>
                        <li className="breadcrumb-item active" dangerouslySetInnerHTML={{__html: `${props.titulo}` }}></li>
                        <div className="col d-flex justify-content-end">
                        <Link to={`/${base_url}/${props.url}/`}>
                            <img className="btn_return" src={Return_arrow} height="25px" alt="Retornar" />
                        </Link>
                        </div>
                    </ol>
                    </nav>
                    <Link to={`/${base_url}/${props.url}/`} className="d-block d-sm-none">
                        <img className="btn_return" src={Return_arrow} height="30px" alt="Retornar" />
                    </Link>
                </div>
            </div>
        </div>
        </>
    );
}
